import { FormControl, MenuItem, Select, Typography, useTheme, Box, Chip } from '@mui/material';
import React from 'react';
import { BRAND_YELLOW } from '../ThemeProvider';
import { useShippingRegionContext } from '../contexts/ShippingRegionContext';
import { useGetAllShippingRegionsQuery } from '../services/shippingRegions';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useTranslation } from 'react-i18next';

export const RegionSelector = () => {
	const { t } = useTranslation();
	const { selectedRegion, updateSelectedRegion, isLoading: isRegionLoading, detectedRegion, hasAutoDetected } = useShippingRegionContext();
	const theme = useTheme();
	const { data: allShippingRegions } = useGetAllShippingRegionsQuery();
    
	const isAutoDetected = hasAutoDetected && detectedRegion && selectedRegion === detectedRegion.countryCode;

	const supportedCountryCodes = ['US', 'EE'];
	const detectedCountryCode = detectedRegion?.countryCode ?? null;
	const regionOptions = allShippingRegions?.filter((region) => supportedCountryCodes.includes(region.code) || (detectedCountryCode && region.code === detectedCountryCode));

	return (
		<FormControl size="small" sx={{minWidth: '15rem', color: 'primary.main'}}>
			<Box display="flex" alignItems="center" gap={1} mb={1}>
				<Typography variant="subtitle2" color="text.secondary">
					{t('regionSelector.selectYourRegion')}
				</Typography>
				{isAutoDetected && (
					<Chip
						icon={<LocationOnIcon />}
						label={`Detected: ${detectedRegion.city}`}
						size="small"
						color="success"
						variant="outlined"
						sx={{ fontSize: '0.7rem', height: 20 }}
					/>
				)}
			</Box>
			<Select 
				value={selectedRegion || ''}
				onChange={(e) => updateSelectedRegion(e.target.value || null)}
				id="shipping-region-select"
				sx={{
					borderRadius: 10, 
					color: theme.palette.primary.main,
					...(selectedRegion ? {} : {
						animation: 'glow 2s ease-in-out infinite alternate',
						'@keyframes glow': {
							from: {
								boxShadow: `0 0 5px ${BRAND_YELLOW}, 0 0 10px ${BRAND_YELLOW}, 0 0 15px ${BRAND_YELLOW}`
							},
							to: {
								boxShadow: `0 0 10px ${BRAND_YELLOW}, 0 0 20px ${BRAND_YELLOW}, 0 0 30px ${BRAND_YELLOW}`
							}
						}
					})
				}}
				disabled={isRegionLoading}
			>
				<MenuItem value="" disabled>
					{t('regionSelector.selectRegionToSeeAvailableShippingOptions')}
				</MenuItem>
				{regionOptions?.map((region) => (
					<MenuItem key={region?.code} value={region?.code}>
						{region?.name}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};